/** When blocked time is created from the schedule quick action, the schedule
 * query can refetch by listening for this event (avoids prop drilling from
 * `BookingsPage` into `BookingsScheduleContent`). */
export const SCHEDULE_BLOCK_TIMES_REFETCH_EVENT =
  'cp:refetch-schedule-block-times'

export function emitScheduleBlockTimesRefetch() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(SCHEDULE_BLOCK_TIMES_REFETCH_EVENT))
}
